import { FunctionComponent, Fragment } from 'react';
import { IProps } from '../../../interfaces/IProps';
import { useStateValue } from '../../../hooks/UseStateValue';

export const ProgressBar: FunctionComponent<IProps> = (props: IProps): JSX.Element => {
  const [{ labels, actualStep }] = useStateValue();

  if (actualStep === 0) {
    return <Fragment />;
  } else if (actualStep < 3 || props.pageType === 'receipt') {
    return (
      <Fragment>
        <div className="progress-bar-inner" />
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <div className={`progress-payment-bar-inner payment-step-${actualStep}`}>
          <InsuranceInformation label={labels.icon.cast.label} className="semi" />
          <Basket
            label={labels.icon.basket.label}
            className={actualStep === 4 ? ' active' : actualStep > 4 ? ' semi' : ' dimmed'}
          />
          <AboutYou
            label={labels.icon.identity.label}
            className={actualStep === 5 ? ' active' : actualStep > 5 ? ' semi' : ' dimmed'}
          />
          <StartDate
            label={labels.icon.calendar.label}
            className={actualStep === 6 ? ' active' : actualStep > 6 ? ' semi' : ' dimmed'}
          />
          <Payment
            label={labels.icon.payment.label}
            className={actualStep > 6 && actualStep < 9 ? ' active' : actualStep > 8 ? ' semi' : ' dimmed'}
          />
          <Accept
            label={labels.icon.accept?.label || 'Godkend køb'}
            className={actualStep > 8 ? ' active' : ' dimmed'}
          />
        </div>
      </Fragment>
    );
  }
};

type lblClsNm = { label: string; className: string };

const InsuranceInformation = ({ label, className }: lblClsNm) => {
  return genericIcon(label, className, 'cast', '50', -50);
};

const Basket = ({ label, className }: lblClsNm) => {
  return genericIcon(label, className, 'basket', '50', -50);
};

const AboutYou = ({ label, className }: lblClsNm) => {
  return genericIcon(label, className, 'contacts', '71', -50);
};

const StartDate = ({ label, className }: lblClsNm) => {
  return genericIcon(label, className, 'cal', '50', -52);
};

const Payment = ({ label, className }: lblClsNm) => {
  return genericIcon(label, className, 'credit-cards', '71', -50);
};

const Accept = ({ label, className }: lblClsNm) => {
  return genericIcon(label, className, 'document-sign', '71', -50);
};

const genericIcon = (label: string, className: string, shape: string, size: string, top: number) => {
  return (
    <div className={`payment-wrapper${className}`}>
      <flos-icon class={`flos-icon icon-${shape}`} shape={shape} size={size} style={{ left: 1010, top: top }} />
      <div>{label}</div>
    </div>
  );
};
